'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var IsValidTypes = ['silver', 'gold'];
var UsisValidTypes = ['basic', 'advantage', 'elite'];

exports.default = function (nextState, replace, routePath) {
  var coverage = nextState.location.query.coverage;

  var validTypes = routePath === 'lloydsis' ? IsValidTypes : UsisValidTypes;

  if (coverage && !validTypes.includes(coverage)) {
    replace('/');
    alert('Coverage type must be one of: ' + ' ' + validTypes);
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/international-students/Path.js
// module id = 1773
// module chunks = 0